type CacheKey = string;

const cache = new Map<CacheKey, unknown>();

export const CACHE_KEYS = {
  chatHistory: (clipId: string) => `chatHistory:${clipId}`,
  recipes: 'recipes',
  recommendedRecipe: (clipId: string) => `recommendedRecipe:${clipId}`,
  editId: (clipId: string) => `editId:${clipId}`
} as const;

export function getFromCache<T>(key: CacheKey): T | null {
  return (cache.get(key) as T | undefined) ?? null;
}

export function setInCache<T>(key: CacheKey, value: T): void {
  cache.set(key, value);
}

export function clearCache(): void {
  cache.clear();
}

export function hasInCache(key: CacheKey): boolean {
  return cache.has(key);
}
